import { TabButtonWrapper, TabWrapper } from './styled'

import { PresentationalStateActions } from '../transactional-context/interface'
import React from 'react'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'
import { useTransactionalContext } from '../transactional-context'

const WidgetTab: React.FC = () => {
  // pull in the transactional context context
  const { isBuying, dispatch, redemptionAsset } = useTransactionalContext()
  const { run, setCurrentStep, currentStep, backFromPortfolio, setBackFromPortfolio, startTour } =
    useTourGuide()

  // only change the state if the button isn't already active
  const toggleBuySell = (transactionType: 'buy' | 'sell') => {
    if (run && currentStep === 8) {
      setCurrentStep(currentStep + 1)
    }
    if (transactionType === 'buy' && !isBuying) {
      dispatch({ type: PresentationalStateActions.CHANGE_TAB_BUY })
      dispatch({ type: PresentationalStateActions.CHANGE_SELL_INPUT_AMOUNT, payload: '' })
      dispatch({
        type: PresentationalStateActions.SET_REDEMPTION_ASSET,
        payload: redemptionAsset,
      })
    } else if (transactionType === 'sell' && isBuying) {
      dispatch({ type: PresentationalStateActions.CHANGE_TAB_SELL })
      dispatch({ type: PresentationalStateActions.CHANGE_BUY_INPUT_AMOUNT, payload: '' })
      dispatch({
        type: PresentationalStateActions.SET_REDEMPTION_ASSET,
        payload: redemptionAsset,
      })
    }
  }

  /**
   * IT: sets up mock STATE
   * WHEN: The tour is running
   */
  React.useEffect(() => {
    if (run && currentStep > 8) {
      dispatch({ type: PresentationalStateActions.CHANGE_TAB_BUY })
      dispatch({ type: PresentationalStateActions.CHANGE_BUY_INPUT_AMOUNT, payload: '' })
      dispatch({
        type: PresentationalStateActions.SET_REDEMPTION_ASSET,
        payload: redemptionAsset,
      })
    } else if (run && currentStep <= 8) {
      dispatch({ type: PresentationalStateActions.CHANGE_TAB_SELL })
      dispatch({ type: PresentationalStateActions.CHANGE_BUY_INPUT_AMOUNT, payload: '' })
      dispatch({
        type: PresentationalStateActions.SET_REDEMPTION_ASSET,
        payload: redemptionAsset,
      })
    }
    if (currentStep === 8 && backFromPortfolio === true) {
      setBackFromPortfolio(false)
      startTour()
    }
    //coming back from portfolio page
  }, [run, currentStep, backFromPortfolio, startTour])

  return (
    <TabWrapper>
      <TabButtonWrapper active={isBuying} onClick={() => toggleBuySell('buy')} id="tour-buy-tab">
        <span>Buy</span>
      </TabButtonWrapper>
      <TabButtonWrapper active={!isBuying} onClick={() => toggleBuySell('sell')}>
        <span>Sell</span>
      </TabButtonWrapper>
    </TabWrapper>
  )
}
export default WidgetTab
